var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('span',[_c('v-skeleton-loader',{staticClass:"mt-2",attrs:{"type":"text","width":"100%","height":"20px"}}),_c('v-skeleton-loader',{staticClass:"mt-2",attrs:{"type":"text","width":"100%","height":"20px"}})],1):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }